import React from 'react';
import { BookOpen } from 'lucide-react';
import PageHero from '../components/common/PageHero';
import BookletList from '../components/booklets/BookletList';

const PublicBooklets = () => (
  <div className="bg-ink-50">
    <PageHero
      icon={BookOpen}
      title="Graduation booklets"
      subtitle="Download graduation programme booklets and ceremony guides"
    />
    <BookletList />
  </div>
);

export default PublicBooklets;
